export default __webpack_public_path__ + "static/media/6.cc3ab001.jpg";